<script setup>
import { useAppStore } from '@/app/stores/app.store.js';
import CFAlert from '@/ui/Alert/CFAlert.vue';
import CFButton from '@/ui/Button/CFButton.vue';
import router from '@/app/router/index.js';
import { usePermissions } from '#modules/auth/composables/usePermissions.js';
import { AppPermissions } from '#modules/auth/constants/permissions.js';

const appStore = useAppStore();
const { can } = usePermissions();
</script>

<template>
    <Transition>
        <div
            v-if="appStore.showMigrationHelp && can(AppPermissions.ManageMigrations)"
            class="shrink-0 px-8"
        >
            <CFAlert
                class="mt-6"
                :title="$t('support.migration_help_alert_title')"
                icon="ab-testing-browsers"
                dismissible
                @close="appStore.showMigrationHelp = false"
            >
                <template #actions>
                    <CFButton
                        color="accent"
                        variant="outline"
                        @click="router.push({ name: 'migration' })"
                    >
                        {{ $t('support.migration_help_alert_link') }}
                    </CFButton>
                </template>
            </CFAlert>
        </div>
    </Transition>
</template>
